






























































import { Component, Mixins, Watch } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import { mapState } from 'vuex';
import _ from 'lodash';
import BusinessCreditCheckList from '@/pages/Admin/Business/BusinessCreditCheckList.vue';

@Component({
  components: {
    BusinessCreditCheckList,
  },
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
    ...mapState('BusinessCreditLevel', {
      businessCreditLevels: 'businessCreditLevels',
    }),
  },
})
export default class BusinessUpdateCreditCheck extends Mixins(CRUDMixins) {
  business!: Model;

  tmpBusiness = {};

  isLoading = false;
  isMounted = false;

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  businessCreditLevels!: [
    {
      object_id: string;
      currency: string;
      level: string;
      amount_limit: string;
    }
  ];

  isApiFetch = {
    isApiFetchCountiesFinished: false,
    isApiFetchBusinessCreditLevelsFinished: false,
  };

  @Watch('business', { deep: true })
  watchBusiness(v) {
    this.tmpBusiness = _.cloneDeep(v);
  }

  mounted() {
    if (!this.countries.length) {
      this.$store
        .dispatch('Country/fetchList', {
          params: {
            expand: ['states'],
          },
        })
        .then(() => {
          this.isApiFetch['isApiFetchCountiesFinished'] = true;
        });
    } else {
      this.isApiFetch['isApiFetchCountiesFinished'] = true;
    }

    if (!this.businessCreditLevels.length) {
      this.$store.dispatch('BusinessCreditLevel/fetchList').then(() => {
        this.isApiFetch['isApiFetchBusinessCreditLevelsFinished'] = true;
      });
    } else {
      this.isApiFetch['isApiFetchBusinessCreditLevelsFinished'] = true;
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
        if (this.business) {
          this.tmpBusiness = _.cloneDeep(this.business);
          this.tmpBusiness['business_credit_level_oid'] = this.business
            .business_credit_level
            ? this.business.business_credit_level.object_id
            : null;
        }
      }
    }
  }

  update() {
    this.isLoading = true;
    this.$store
      .dispatch('Business/creditLevel', {
        businessOid: this.$route.params.businessOid,
        config: {
          business_credit_level_oid: this.tmpBusiness[
            'business_credit_level_oid'
          ],
        },
      })
      .then(() => {
        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: this.$i18n.t('common_word.success_update'),
        });
      });
  }

  get filteredBusinessCreditLevels() {
    return this.businessCreditLevels.filter(
      (level) => level.currency == this.business.currency
    );
  }
}
